<script>
import { mapActions, mapState } from 'vuex';
import { orderBy } from 'lodash';

export default {
  props: ['value'],
  data() {
    return {
      channelSkills: [],
      sending: false,
      MIN_COUNT: 1,
      MAX_COUNT: 100,
      loading: false,
    };
  },
  computed: {
    ...mapState('channel', ['channels']),
  },
  created() {
    this.loading = true;
    this.fetchChannelsPagination({ page: 1, pageSize: this.channels.length })
      .then(() => {
        this.updateChannels();
        this.loading = false;
      });
  },
  methods: {
    ...mapActions('channel', ['fetchChannelsPagination', 'updateRequestTypePriority']),
    async updateRequestTypesPriorities() {
      const promises = this.channelSkills.map((skill) => this.updateRequestTypePriority({
        id: skill.id,
        weight: skill.value,
      }));
      await Promise.all(promises);
    },
    updateChannels() {
      const currentChannel = this.channels.find((channel) => channel.id === this.value.id);
      this.channelSkills = orderBy(currentChannel.requestTypePriorities.map((skill) => ({
        id: Number(skill.id),
        title: skill.requestType.name,
        value: skill.weight === 0 ? 1 : skill.weight,
        active: skill.requestType.active,
      })), ['title']);
    },
    save() {
      this.sending = true;
      this.updateRequestTypesPriorities().then(() => {
        this.sending = false;
        this.close();
      });
    },
    close() {
      this.$parent.close([null]);
    },
  },
};
</script>

<template lang="pug">
div(:class="$style.root" v-if="!loading")
  header(:class="$style.header")
    ui-user-badge(
      :title="value.name",
      :subtitle="value.type",
      :type="value.type")
  div(:class="$style.content")
    div(:class="$style.contentTitle") {{ $t('T_REQUEST_TYPE') }}
    div(:class="$style.contentTitle") {{ $t('T_PRIORITY') }}
    div(v-for="skill in channelSkills", :class="[$style.skill, !skill.active && $style.skillDisabled]")
      div(:class="$style.skillLabelWrap")
        div(:class="$style.skillLabel") {{ skill.title }}
      div
        div(:class="$style.visibilityIconWrap")
          ui-icon(:class="[$style.visibilityIcon, $style.disabled]",
            v-show="!skill.active") visibility_off
        div(:class="$style.visibilityIconWrap")
          ui-icon(:class="$style.visibilityIcon",
            v-show="skill.active") visibility
      div(:class="$style.skillLevel")
        ui-range(v-model="skill.value", :min="MIN_COUNT", :max="MAX_COUNT")
      ui-input-number(
        :class="$style.skillCount",
        :value="skill.value",
        :min="MIN_COUNT",
        :max="MAX_COUNT",
        v-model="skill.value",
        :zero="false")
    div(:class="$style.notification") {{ $t('T_MODAL_CHANNEL_SKILL_PRIORITY_NOTIFICATION') }}
  footer(:class="$style.footer")
    ui-button(@click.native="close()", @keyup.enter.native="close()") {{ $t('T_CANCEL') }}
    ui-button(:class="$style.save", @click.native="!sending ? save() : ''",
      @keyup.enter.native="!sending ? save() : ''",
      :disabled="sending") {{ $t('T_SAVE') }}
</template>

<style lang="sass" module>
.root
  display: block
  max-height: 90vh
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
.footer
  padding: 24px
  text-align: right
  border-top: 1px solid $color_divider
.content
  padding: 40px 30px 25px 40px
  min-width: 532px
  &Title
    font-size: $title_size
    font-weight: 400
    text-transform: uppercase
    white-space: nowrap
    line-height: $title_size
    height: $title_size
    box-sizing: unset
    transition: color $a_speed, border-color $a_speed
    color: $color_text_second
    border-color: $color_main
    display: inline-block
    width: 275px
    padding-bottom: 16px
    & + &
      width: 250px
      margin-right: 0
.skill
  display: flex
  flex-shrink: 0
  align-items: center
  line-height: 18px
  transition: color $a_speed
  & + &
    margin-top: 16px
  &Disabled
    color: $color_text_second
  &Label
    width: 168px
    overflow: hidden
    text-overflow: ellipsis
    font-size: 14px
    margin-right: 24px
    &.disabled
      color: $color_text_second
    &Wrap
      display: flex
      align-items: center
  &Count
    margin-left:25px
    font-size: 16px
    color: $color_text_second
    vertical-align: baseline
    white-space: nowrap
    width: 50px
    padding: 0
    display: block
    border-width: 0 !important
  &Level
    width: 248px
    display: flex
    flex-direction: column
    align-items: stretch
    .channels
      padding: 0
      color: $s_color_main !important
.save
  color: $color_main !important
.skillLabel
  word-break: break-word
  overflow-wrap: break-word
.notification
  white-space: pre-wrap
  margin-top: 25px
  color: $color_main_second
  width: 490px
  font-size: 14px
.visibilityIcon
  width: 24px
  height: 24px
  &Wrap
    width: 24px
    margin: 0 30px
</style>
